import { useEffect } from 'react';
import { setIsShowMessageIcon } from 'models/common';

export const useShowMessageIcon = () => {
  useEffect(() => {
    setIsShowMessageIcon(true);
    return () => setIsShowMessageIcon(false);
  }, []);
};
